// extracted by mini-css-extract-plugin
module.exports = {"spacer":"GiftCardPaymentContainer__spacer___2viQA"};